export default "__VITE_ASSET__ac1560dd__"